import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Redirect } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import Button from "sweet-web/components/universal/Button";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import Input from "sweet-web/components/universal/Input";
import { Label, Title } from "sweet-web/components/universal/Text";
import { Form, Section } from "sweet-web/components/universal/View";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import { LogIn, ResetPassword } from "sweet-web/redux/auth/actions";
import * as selectors from "sweet-web/redux/selectors";

type OwnProps = {};
type Props = OwnProps & RouteComponentProps & ConnectedProps<typeof connector>;

const Login: React.FC<Props> = props => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loggedIn, loading } = props;

  if (loggedIn) {
    return <Redirect to={"/"} />;
  }

  const forgotPassword = async () => {
    if (!email) {
      alert("Enter your email address");

      return;
    }
    await props.ResetPassword(email);
    alert("Check your email");
  };

  return (
    <Form
      onSubmit={e => {
        e.preventDefault();
        props.LogIn(email, password);
      }}
      style={{ marginTop: "15%" }}
    >
      <Title>Login</Title>
      <Input
        title={"Email"}
        value={email}
        onChange={value => {
          setEmail(value);
        }}
      />

      <Input
        title={"Password"}
        type={"password"}
        value={password}
        onChange={value => {
          setPassword(value);
        }}
      />
      <Button submit={true} loading={loading} title="Submit" />
      <OutlineButton
        color="gray"
        style={{ marginTop: 15 }}
        title="Forgot Password"
        onClick={forgotPassword}
      />
    </Form>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => ({
  loading: selectors.isAuthenticating(state),
  loggedIn: selectors.loggedIn(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      LogIn,
      ResetPassword
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Login);
